import React from 'react';
import TentTopPath from '../../SVGs/icons/tent_top_path.js';

export default function TentTopMark({
  width = 40,
  height = 28,
  circleClassName = '',
  svgClassName = '',
}) {
  return (
    <span className={`tent-top-circle${circleClassName ? ` ${circleClassName}` : ''}`}>
      <TentTopPath
        width={width}
        height={height}
        className={`tent-top-svg${svgClassName ? ` ${svgClassName}` : ''}`}
        style={{ display: 'block' }}
      />
    </span>
  );
}
